import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';

import { ChooseDeliveryTypeComponent } from './components/choose-delivery-type/choose-delivery-type.component';
import { ChooseOutletComponent } from './components/choose-outlet/choose-outlet.component';
import { DeliveryToDoorComponent } from './components/delivery-to-door/delivery-to-door.component';
import { MailDeliveryToDoorComponent } from './components/mail-delivery-to-door/mail-delivery-to-door.component';
import { PickupOutletComponent } from './components/pickup-outlet/pickup-outlet.component';
import { ChooseDeliveryAddressModalComponent } from './components/choose-delivery-address-modal/choose-delivery-address-modal.component';
import { DeliveryDaysInfoComponent } from './components/delivery-days-info/delivery-days-info.component';

import { DeliveryAvailabilityService } from './services/delivery-availability.service';
import { CitiesApiService } from '../api-services/services/cities-api.service';
import { DeliveryApiService } from '../api-services/services/delivery-api.service';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { SoldOutMsgComponent } from './components/sold-out-msg/sold-out-msg.component';
import { GiftDeliveryComponent } from './components/gift-delivery/gift-delivery.component';
import {
  GiftDeliveryRecipientsFormComponent
} from './components/gift-delivery/gift-delivery-recipients-form/gift-delivery-recipients-form.component';
import {
  GiftDeliveryTypeSelectorComponent
} from './components/gift-delivery/gift-delivery-type-selector/gift-delivery-type-selector.component';
import {
  GiftSendMessageSelectorComponent
} from './components/gift-delivery/gift-send-message-selector/gift-send-message-selector.component';
import { ProductAvailabilityNoticeComponent } from './components/product-availability-notice/product-availability-notice.component';
import { DeliveriesNotesComponent } from './components/deliveries-notes/deliveries-notes.component';
import { ThirdPartyDeliveryComponent } from './components/third-party-delivery/third-party-delivery.component';
import { NgBusyModule } from 'ng-busy';
import { DeliveryUiHelperService } from './services/delivery-ui-helper.service';
import {
  DeliveryToDoorOldComponent
} from './components/delivery-to-door-old/delivery-to-door-old.component';
import { CustomDeliveryTimesComponent } from './components/custom-delivery-times/custom-delivery-times.component';
import { PickupAsapComponent } from './components/pickup-asap/pickup-asap.component';
import { ToDoorAsapChoiceComponent } from './components/to-door-asap-choice/to-door-asap-choice.component';
import {
  PickupCustomOpeningTimeComponent
} from './components/pickup-custom-opening-time/pickup-custom-opening-time.component';
import {
  DailyStockSoldOutNoticeComponent
} from './components/daily-stock-sold-out-notice/daily-stock-sold-out-notice.component';

const EXPORTED_COMPONENTS = [
  ChooseDeliveryTypeComponent,
  ChooseOutletComponent,
  DeliveryToDoorComponent,
  DeliveryToDoorOldComponent,
  MailDeliveryToDoorComponent,
  DeliveryDaysInfoComponent,
  CustomDeliveryTimesComponent,
  GiftDeliveryComponent,
  ThirdPartyDeliveryComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    TranslateModule.forChild(),
    NgbModule,
    ScrollToModule,
    NgBusyModule,
  ],
  exports: [
    ...EXPORTED_COMPONENTS
  ],
  declarations: [
    ...EXPORTED_COMPONENTS,

    PickupOutletComponent,
    ChooseDeliveryAddressModalComponent,
    SoldOutMsgComponent,
    GiftDeliveryRecipientsFormComponent,
    GiftDeliveryTypeSelectorComponent,
    GiftSendMessageSelectorComponent,
    ProductAvailabilityNoticeComponent,
    DeliveriesNotesComponent,
    DailyStockSoldOutNoticeComponent,
    CustomDeliveryTimesComponent,
    PickupAsapComponent,
    PickupCustomOpeningTimeComponent,
    ToDoorAsapChoiceComponent,
  ],
  providers: [
    DeliveryApiService,
    CitiesApiService,
    DeliveryUiHelperService,
  ]
})
export class DeliveryModule {
  static forRoot(): ModuleWithProviders<DeliveryModule> {
    return {
      ngModule: DeliveryModule,
      providers: [
        DeliveryAvailabilityService
      ]
    };
  }
}
